/**
 * What is worth telling a reviewer about a §302 Fall that **is** being billed
 * (TM-9538 / #1514).
 *
 * ⚠ **A note is not a skip, and the difference is the whole point of this
 * enum.** Each of the four below was, at some point in the §302 tickets,
 * proposed as a reason to set the Fall aside; each was rejected as stricter
 * than the rule. Keeping them as notes is what stops that recommendation
 * coming back a fifth time — the case is visible, and it is billed.
 *
 * Flat, German string literals, like the skip reasons beside it: the value is
 * what lands in the tooltip.
 */
export var GkvBillingCandidateNote;
(function (GkvBillingCandidateNote) {
    /**
     * No Versichertennummer on the card.
     *
     * `INV.Versichertennummer` is transmitted where it is known, and §302 has no
     * rule that refuses a Fall without one. The Kasse identifies the insured from
     * name plus Geburtsdatum in that case; the Fall goes out.
     */
    GkvBillingCandidateNote["MEMBER_NUMBER_MISSING"] = "versichertennummer fehlt";
    /**
     * A part of the Versichertenstatus lies outside its published value set.
     *
     * The `SLGA.GES` Summenstatus buckets on Stelle 1 alone, and everything it
     * does not recognise lands in `99` — "nicht zuzuordnende Status", a
     * **defined** bucket, not an error. The file stays valid.
     */
    GkvBillingCandidateNote["VERSICHERTENSTATUS_AUSSERHALB_WERTEMENGE"] = "versichertenstatus au\u00DFerhalb der wertemenge";
    /**
     * Street, Postleitzahl or Ort is missing from the patient's address.
     *
     * The `NAD` segment degrades and the Fall lands in Summenstatus `99` —
     * again a defined bucket. Refusing it would hold up revenue on a Verordnung
     * that is entirely lawful.
     */
    GkvBillingCandidateNote["ANSCHRIFT_UNVOLLSTAENDIG"] = "anschrift unvollst\u00E4ndig";
    /**
     * The Kostenträger publishes no Papierannahmestelle, so the destination of
     * the Urbeleg has to be looked up by hand.
     *
     * ⚠ **Not the same as a missing Datenannahmestelle**, which is a hard skip:
     * `UNB.S003 Empfänger` is required and a guessed recipient fails Prüfstufe 1,
     * rejecting the whole Nutzdatendatei. The paper address is a line on a sheet
     * a human posts. 18 of 958 card IKs in the committed corpus are affected,
     * exactly AOK Baden-Württemberg, whose Papierannahmestellen left the
     * Kostenträgerdatei on 01.07.2007 — a documented carve-out, not a data fault.
     */
    GkvBillingCandidateNote["PAPIERANNAHMESTELLE_FEHLT"] = "papierannahmestelle fehlt";
})(GkvBillingCandidateNote || (GkvBillingCandidateNote = {}));
//# sourceMappingURL=gkv-billing-candidate-note.enum.js.map